import ButtonBePremium from "./ButtonBePremium";
export default ButtonBePremium;
